

<template>
  <div class="content_list">
    <div class="list_item" v-for="(item,index) in productLists" :key="index" @click="item_click(item)">
      <div class="image_box">
        <el-image class="item_img" :src="item.image"></el-image>

      </div>
      <div class="item_text1 margin_bottom">{{ langSet=='cn'?item.product_name :item.en_product_name}}</div>
      <div class="item_text2 margin_bottom">{{langSet=='cn'? '产品类别：' + item.categoryNameCnEn.category_name:'Product Category：' + item.categoryNameCnEn.en_category_name }}</div>
    </div>
  </div>

</template>
<script>
export default {
  name: "product_list",
  props:['productLists','external'],
  data(){
    return {
    }
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods:{
    item_click(item){
      if(this.external){
        this.$emit('item_click',item,this.external);
      }else {
        this.$emit('item_click',item);
      }

    }
  }
}
</script>
<style scoped lang="scss">
.content_list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
.list_item {
  padding: 15px;
  //width: 305px;
  height: 280px;
  background: #F7F8FA;
  box-sizing: border-box; /* 确保内边距/边框不影响宽度 */
  text-align: center;
  flex: 0 0 calc(25% - 20px); /* 25%宽度减去左右外边距 */
  margin: 10px;
  overflow: hidden;
  cursor: pointer;
  &:hover{
    border: 1px solid #004190;
  }
}
.image_box {
  //width: 275px;
  height: 155px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}

.item_img {
  width: 135px !important;
  height: 135px !important;
}
.item_text1 {
  font-weight: 600;
  font-size: 20px;
  color: #2C2C2E;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.item_text2 {
  font-weight: 400;
  font-size: 18px;
  color: #757575;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
.margin_bottom {
  width: 100%;
  margin-bottom: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media only screen and (max-width: 767px) {
  .content_list{
    margin: 0;
    justify-content: space-between;
  }
  .list_item{
    height: 3.83rem;
    padding: 0.19rem;
    background: #F7F8FA;
    margin: 0 0.08rem 0.19rem;
    flex: 0 0 calc(50% - 0.19rem);
    .image_box{
      height: 2.31rem;
      margin-bottom: 0.19rem;
      .item_img{
        width: 100% !important;
        height: 100% !important;
      }
    }
    .item_text1{
      font-size: 0.29rem;
      line-height: 0.4rem;
    }
    .margin_bottom{
      margin-bottom: 0.1rem;
    }
    .item_text2{
      margin-bottom: 0;
      font-size: 0.25rem;
      line-height: 0.35rem;
    }
  }
}
</style>